import { CART_SET, BAG_OPEN, BAG_CLOSE, BAG_LOADING } from '../actions/bagActions';

// Mirror of the current Shopify cart. The cart ID is the only thing persisted
// (in localStorage, by the actions); everything here is refreshed from Shopify.
const empty = {
	cartId: null,
	checkoutUrl: null,
	lines: [], // { lineId, variantId, title, variantTitle, price, image, qty }
	subtotal: '0',
	totalQuantity: 0,
};

const initialState = {
	...empty,
	isOpen: false,
	loading: false,
};

export default function bag(state = initialState, action) {
	switch (action.type) {
		case CART_SET: {
			const cart = action.payload;
			if (!cart) return { ...state, ...empty };
			return {
				...state,
				cartId: cart.id,
				checkoutUrl: cart.checkoutUrl,
				lines: cart.lines,
				subtotal: cart.subtotal,
				totalQuantity: cart.totalQuantity,
			};
		}
		case BAG_LOADING:
			return { ...state, loading: action.payload };
		case BAG_OPEN:
			return { ...state, isOpen: true };
		case BAG_CLOSE:
			return { ...state, isOpen: false };
		default:
			return state;
	}
}
